"use strict";
exports.__esModule = true;
exports.fetchEnvVariables = exports.createNewAction = exports.updateAgent = exports.deleteAction = exports.updateAction = exports.getActionData = exports.getVoiceModels = exports.getModels = exports.getActions = exports.getAgents = void 0;
var utils_1 = require("@src/api/utils");
var const_1 = require("@src/const");
exports.getAgents = function (domainId, toolType) {
    var url = const_1.BASE_URL + "domain/" + domainId + "/ai_agents/";
    if (Number.isInteger(toolType)) {
        url = const_1.BASE_URL + "domain/" + domainId + "/ai_agents/?tool_id=" + toolType;
    }
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.getActions = function (agentId) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/actions/";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.getModels = function (domainId) {
    var url = const_1.BASE_URL + "ai_agents/models/?domain_id=" + domainId + "&tool=classic";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.getVoiceModels = function () {
    var url = const_1.BASE_URL + "ai_agents/models/?tool=voice";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.getActionData = function (agentId, action_id) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/action/" + action_id + "/";
    return utils_1.mogamboRequestV3(url, 'GET');
};
exports.updateAction = function (agentId, action_id, data) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/action/" + action_id + "/";
    return utils_1.mogamboRequestV3(url, 'PUT', data);
};
exports.deleteAction = function (agentId, action_id) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/action/" + action_id + "/?delete=true";
    return utils_1.mogamboRequestV3(url, 'POST');
};
exports.updateAgent = function (domainId, ai_agent, data) {
    var url = const_1.BASE_URL + "domain/" + domainId + "/ai_agent/" + ai_agent + "/";
    return utils_1.mogamboRequestV3(url, 'PUT', data, null, {});
};
exports.createNewAction = function (agentId, data) {
    var url = const_1.BASE_URL + "ai_agents/" + agentId + "/action/";
    return utils_1.mogamboRequestV3(url, 'POST', data, null);
};
exports.fetchEnvVariables = function (domainId) {
    var url = const_1.BASE_URL + "domain/env_variables/" + domainId + "/";
    return utils_1.mogamboRequestV3(url, 'GET');
};
